@if(eventDetails(); as eventDetails){
<div class='event-dialog-details-part'>

	<table style='width:100%' class='pro-table pro-table-no-header pro-table-with-labels pro-table-without-border'>

		<tr>
			<td>Accelerator </td>
			<td>
				{{ eventDetails.accName }}
			</td>
		</tr>

		<tr>
			<td>Event Time</td>
			<td>
				@if(eventDetails.eventTime){
				<div>{{eventDetails.eventTime}} for {{eventDetails.duration}}</div>
				}
				@else {
				<div class='missing-value'>Dates Not Provided</div>
				}
			</td>
		</tr>

		<!------------- Tool start and end dates/times  --------------->

		@if(eventDetails.toolIconMessage){
		<tr>
			<td kendoTooltip>
				<i class='far fa-question-circle tool-info-icon' [title]='eventDetails.toolIconMessage'
					(click)='toolIconClick(eventDetails.toolIconMessage)'></i>
				Tool Enabled
			</td>
			<td>
				@if(eventDetails.toolEventTime){
				<div>{{eventDetails.toolEventTime}} for {{eventDetails.toolDuration}}</div>
				}
				@else {
				<div class='missing-value'>Dates Not Provided</div>
				}
			</td>
		</tr>
		}

		<!------------- Host  --------------->

		<tr>
			<td>Host</td>
			<td>
				<a class='link' (click)="openPersonDialog()">{{eventDetails.hostName}}</a>
			</td>
		</tr>

		<!------------- Location  --------------->

		<tr>
			<td>Location</td>
			<td>
				@if(eventDetails.venue){
				<div>
					@if(eventDetails.venue.website){
					<a [href]='eventDetails.venue.website' target='_blank'>{{eventDetails.venue.displayedName}}</a>
					}
					@else {
					<ng-container>{{eventDetails.venue.displayedName}}</ng-container>
					}
				</div>
				}
				@else{
				<div>Online</div>
				}
			</td>
		</tr>


		<!------------- Link and Notes  --------------->

		<tr>
			<td>Link</td>
			<td>
				@if(eventDetails.link){
				<a [href]='eventDetails.link' target='_blank'>{{eventDetails.link}}</a>
				}
				@else {
				<div class="missing-value">Link Not Provided</div>
				}
			</td>
		</tr>

		<tr>
			<td>Public Notes</td>
			<td>
				@if(eventDetails.publicNotes){
				<div class="public-notes">{{eventDetails.publicNotes}}</div>
				}
				@else {
				<div class="missing-value">Notes Not Provided</div>
				}
			</td>
		</tr>

	</table>

</div>
}